import React from "react";
import { Link } from "react-router-dom";
import Frame from "../components/Frame";
import EventTile from "../components/EventTile";
import Social from "../components/Social";
import { EVENTS } from "../lib/events";

const GALLERY_PEEK = [
  "/sunstate/gallery/hotel-red-1.jpg",
  "/sunstate/gallery/home-halloween.jpg",
  "/sunstate/gallery/picnic-1.jpg",
  "/sunstate/gallery/hotel-classic-bw.jpg",
];

export const Home = () => {
  return (
    <div className="sc-page sc-page-home" data-testid="page-home">
      {/* HERO — compact */}
      <Frame as="section" className="sc-hero sc-hero-compact" testId="hero-section">
        <div className="sc-hero-eyebrow">
          <span>GOLD COAST</span>
          <span className="sc-hero-eyebrow-dot">·</span>
          <span>BRISBANE</span>
          <span className="sc-hero-eyebrow-dot">·</span>
          <span>QUEENSLAND</span>
        </div>
        <img
          src="/sunstate/logo.png"
          alt="Sunstate Collective"
          className="sc-hero-logo"
        />
        <h1 className="sc-hero-title">
          Luxury event planning, styling and coordination
          <br />
          <span className="sc-hero-title-sub">across Gold Coast and Brisbane</span>
        </h1>
        <p className="sc-hero-sub">
          Curating timeless celebrations with refined detail, elevated styling,
          and seamless execution.
          <br />
          Explore our enquiry options below and let us bring your vision to
          life.
        </p>
      </Frame>

      {/* EVENT TILES */}
      <Frame as="section" className="sc-events" testId="events-section">
        <header className="sc-section-head">
          <span className="sc-section-eyebrow">OUR EXPERIENCES</span>
          <h2 className="sc-section-title">Choose your celebration</h2>
        </header>

        <div className="sc-tiles-grid" data-testid="event-tiles-grid">
          {EVENTS.map((ev, i) => (
            <EventTile event={ev} index={i} key={ev.slug} />
          ))}
        </div>
      </Frame>

      {/* PROCESS */}
      <Frame as="section" className="sc-process" testId="process-section">
        <header className="sc-section-head">
          <span className="sc-section-eyebrow">HOW IT WORKS</span>
          <h2 className="sc-section-title">A considered, four-step process</h2>
        </header>

        <ol className="sc-process-list">
          <li>
            <span className="sc-process-num">01</span>
            <h3>Enquire</h3>
            <p>
              Share your vision, occasion, package preferences and any
              personalisation through our online enquiry form.
            </p>
          </li>
          <li>
            <span className="sc-process-num">02</span>
            <h3>Personalised Quote</h3>
            <p>
              Within 48 hours we&rsquo;ll send you a tailored quote with full
              package details, inclusions and transparent pricing.
            </p>
          </li>
          <li>
            <span className="sc-process-num">03</span>
            <h3>Confirm &amp; Plan</h3>
            <p>
              Approve your quote, pay your retainer and let us handle every
              detail leading up to your event.
            </p>
          </li>
          <li>
            <span className="sc-process-num">04</span>
            <h3>Celebrate</h3>
            <p>
              We style, set up and coordinate so you can step into the moment
              and enjoy it fully.
            </p>
          </li>
        </ol>
      </Frame>

      {/* GALLERY PEEK */}
      <Frame as="section" className="sc-gallery-peek" testId="gallery-peek">
        <header className="sc-section-head">
          <span className="sc-section-eyebrow">FROM OUR PORTFOLIO</span>
          <h2 className="sc-section-title">Moments we&rsquo;ve styled</h2>
        </header>
        <div className="sc-peek-grid">
          {GALLERY_PEEK.map((src, i) => (
            <div
              className="sc-peek-tile"
              key={i}
              style={{ backgroundImage: `url(${src})` }}
              aria-hidden="true"
            />
          ))}
        </div>
        <div className="sc-section-foot">
          <Link to="/gallery" className="sc-btn-ghost" data-testid="gallery-peek-cta">
            VIEW THE FULL GALLERY
          </Link>
        </div>
      </Frame>

      {/* SOCIAL */}
      <Frame as="section" className="sc-social-section" testId="social-section">
        <header className="sc-section-head">
          <span className="sc-section-eyebrow">FOLLOW OUR JOURNEY</span>
          <h2 className="sc-section-title">Stay connected</h2>
          <p className="sc-section-sub">
            Behind-the-scenes styling, fresh setups and inspiration —
            shared daily across our socials.
          </p>
        </header>
        <Social variant="inline" />
      </Frame>

      {/* CTA */}
      <Frame as="section" className="sc-cta" testId="cta-section">
        <h2 className="sc-cta-title">Ready to begin?</h2>
        <p className="sc-cta-sub">
          Tell us about your celebration and we&rsquo;ll craft something
          unforgettable.
        </p>
        <div className="sc-cta-btns">
          <Link to="/events" className="sc-btn-primary" data-testid="cta-events">
            START AN ENQUIRY
          </Link>
          <a
            href="mailto:sunstatecollective@gmail.com"
            className="sc-btn-ghost"
            data-testid="cta-email"
          >
            EMAIL US DIRECTLY
          </a>
        </div>
      </Frame>
    </div>
  );
};

export default Home;
